'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:Assignment
 * @description
 * # AssignmentService
 */
angular.module('thothApp.services')
  .factory('Assignment', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_CLIENT_URL = domain.name + '/api/v1/assignments/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_CLIENT_URL,
      baseModelName: 'assignment'
    });

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    baseService.index = function(params) {
      return $http.get(BASE_CLIENT_URL, { params: params });
    };

    baseService.destroy = function(id) {
      return $http.delete(BASE_CLIENT_URL + id);
    };

    baseService.find = function(id, params) {
      return $http.get(BASE_CLIENT_URL + id, { params: params });
    };

    baseService.create = function(payload) {
      return $http.post(BASE_CLIENT_URL, payload);
    };

    baseService.update = function(id, payload) {
      return $http.put(BASE_CLIENT_URL + id, payload);
    };

    return baseService;
  }]);
